import { useLocalPersistedState } from '@neo.tax/shared/hooks';
import { LocalPersistenceKey } from '@neo.tax/shared/types';

import { ColumnDefinition } from '../../filter-popover';
import { Sorting, SortingState, makeSortingSchema } from './types';

export const useSorting = <ColumnName extends string>({
  columns,
  initialSorting,
  persistenceKey,
}: {
  columns: readonly ColumnDefinition<ColumnName>[];
  initialSorting?: Sorting<ColumnName>[];
  persistenceKey?: LocalPersistenceKey;
}): SortingState<ColumnName> => {
  const [sorts, setSorts, resetSorts] = useLocalPersistedState({
    dataSchema: makeSortingSchema(columns.map((c) => c.name)),
    initialData: initialSorting ?? [],
    persistenceKey: persistenceKey ? `sorting:${persistenceKey}` : null,
  });

  return {
    resetSorts,
    setSorts,
    sorts,
    columns,
  };
};
